var map = {
	"./cant_use.png": 4921,
	"./connectivity.png": 4212,
	"./covers.png": 2296,
	"./crashing.png": 7589,
	"./hand_connect.png": 3089,
	"./input_graph_issue.png": 1867,
	"./inviting.png": 5664,
	"./login.png": 622,
	"./login_fail.png": 4974,
	"./loud_noise.png": 6477,
	"./movement.png": 3838,
	"./other_catagory.png": 3761,
	"./power.png": 1382,
	"./screen_and_back_button.png": 3169,
	"./setup_wizard.png": 8450,
	"./software_update.png": 9149,
	"./triggers.png": 7401,
	"./user_control.png": 1165,
	"./wrist.png": 7068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4480;